import { useQuery, useMutation, useQueryClient } from "react-query";
import { toolsApi } from "../services/toolsApi";

export function useAllTools() {
  return useQuery("allTools", toolsApi.listAll, { staleTime: 60_000 });
}

export function useUserTools(userId: string | undefined) {
  return useQuery(
    ["userTools", userId],
    () => toolsApi.getUserTools(userId!),
    { enabled: !!userId, staleTime: 30_000 }
  );
}

export function useSetUserTools(userId: string) {
  const qc = useQueryClient();
  return useMutation(
    (tool_ids: string[]) => toolsApi.setUserTools(userId, tool_ids),
    {
      onSuccess: () => {
        qc.invalidateQueries(["userTools", userId]);
      },
    }
  );
}
